import React from "react";
import { DesignEditor } from "~/components/docx-proposal/template-editor";
import { OutputDesignType, GroupedEntityType } from "~/gql/graphql";

import styles from "./template-editor.module.css";

const { ["container"]: containerClassName } = styles as any;

export const TextBlockEditorPage = () => {
  return (
    <div className={containerClassName}>
      <DesignEditor
        outputDesignType={OutputDesignType.TextBlock}
        groupedEntityType={GroupedEntityType.ProposalOutput}
      />
    </div>
  );
};
